import { Component, HostBinding, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { map, Observable } from 'rxjs';

import { FilterPanelService } from '../../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-data-filter-button',
  templateUrl: './data-filter-button.component.html',
  styleUrls: ['./data-filter-button.component.scss']
})
export class DataFilterButtonComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @HostBinding('class.hidden')
  private isHidden: boolean;

  @Input() isOneOfPanelsOpen: boolean;

  isPanelClosed$: Observable<boolean>;

  constructor(private dataFilterManagerService: FilterPanelService) {}

  ngOnInit(): void {
    this.isPanelClosed$ = this.dataFilterManagerService.isOpen().pipe(map((isOpen) => !isOpen));
    this.isPanelClosed$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isClosed) => (this.isHidden = !isClosed));
  }

  open(): void {
    this.dataFilterManagerService.open();
  }
}
